import React from "react";

import { RichTextField } from "../../../../../components/ui/RichTextField";
import ListingLanguageBlock from "../components/ListingLanguageBlock";
import { fieldHint, fieldInput, fieldLabel } from "../listingEditorStyles";

/**
 * "Beschreibung": title and body text, once per language.
 *
 * The two languages are stacked rather than placed side by side. The rich-text
 * editor carries a six-button toolbar above a prose area; halving its width to
 * fit two of them makes both cramped, and nothing here needs comparing line by
 * line the way the amenity fields do.
 *
 * The RichTextField itself is untouched: same `id`/`name`/`value` props and the
 * same markdown string out of `onChange`. It brings its own character count, so
 * this section deliberately does not add a second one.
 */
export default function ListingDescriptionSection({ form, setForm, onChange }) {
  const setBody = (field) => (markdown) =>
    setForm((prev) => ({ ...prev, [field]: markdown }));

  return (
    <>
      <ListingLanguageBlock title="Deutsch" code="DE">
        <div>
          <label htmlFor="listing-title-de" className={fieldLabel}>
            Titel
          </label>
          <input
            id="listing-title-de"
            type="text"
            name="title_de"
            value={form.title_de}
            onChange={onChange}
            placeholder="Titel DE"
            className={fieldInput}
          />
          <p className={fieldHint}>Öffentlicher Titel des Inserats.</p>
        </div>

        <div>
          <label className={fieldLabel}>Beschreibung</label>
          <RichTextField
            id="description_de"
            name="description_de"
            value={form.description_de}
            onChange={setBody("description_de")}
            placeholder="Beschreibung DE"
          />
        </div>
      </ListingLanguageBlock>

      <ListingLanguageBlock title="English" code="EN">
        <div>
          <label htmlFor="listing-title-en" className={fieldLabel}>
            Title
          </label>
          <input
            id="listing-title-en"
            type="text"
            name="title_en"
            value={form.title_en}
            onChange={onChange}
            placeholder="Title EN"
            className={fieldInput}
          />
          <p className={fieldHint}>Public listing title.</p>
        </div>

        <div>
          <label className={fieldLabel}>Description</label>
          <RichTextField
            id="description_en"
            name="description_en"
            value={form.description_en}
            onChange={setBody("description_en")}
            placeholder="Description EN"
          />
        </div>
      </ListingLanguageBlock>
    </>
  );
}
